import React, { Component, Fragment } from 'react';
import GifBrowser from '../GifBrowser/GifBrowser';
import './ChampagneRoom.scss';
import DATA from "../../__vip-yes.js";
class ChampagneRoom extends Component { 
    constructor(props) {
        super(props);   
        this.state = {
            vip : props.vip
        }    
    }
    componentDidMount () {
        // ready
    }
    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.vip !== prevProps.vip) {
            this.setState({
                vip : this.props.vip
            })
        }
    }
    render () {
        let _class = this.props.layout;
        return (
            <div class="ChampagneRoom">
                { !this.state.vip && 
                <div onClick={ this.props.handleShowVIP } class="ChampagneRoom--advert">
                    <div>
                        <img src="/assets/img/gifs/arrow.gif" />
                        <div class="ChampagneRoom--advert--grid">
                            <img src="/assets/img/gifs/click.gif" />
                            <img src="/assets/img/gifs/that.gif" />
                            <img src="/assets/img/gifs/button.gif" />
                        </div>
                        <div class="ChampagneRoom--advert--body">
                            <h2>You got the Klue Chrome Extension?</h2>
                            <h3>Click it to go VIP</h3>
                            <a href="http://klue.com">What&apos;s Klue?</a>
                            <button>Dismiss</button>
                        </div>
                    </div>
                </div>
                }
                { this.state.vip &&
                    <GifBrowser 
                        data={ DATA } 
                        row={ this.props.row } 
                        layout={ this.props.layout } 
                        gif={ this.props.gif } 
                        history={ this.props.history } 
                        location={ this.props.location }
                        handleModal={ this.props.handleModal }
                    />
                }
            </div>
        );
    }
}

export default ChampagneRoom;